function isSiteSubsection() {
    const pathnameList = location.pathname.split('/').filter((el) => el)
    return pathnameList.length > 1
}
